import { del, get, post, put } from '@api/api';
import API_ROUTES from '@api/routes';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ICompany, IProjectCreate, IProjectSettings } from 'types/settings';
import { IProject } from 'types/users';
import QueryKeys from '.';

const getProjectSettings = async () => {
	const res = await get<IProjectSettings>(API_ROUTES.v1.project);
	return res.data;
};

const setProjectSettings = async (body: IProjectSettings) => {
	const res = await put<IProjectSettings>(API_ROUTES.v1.project, body);
	return res.data;
};

const getCompany = async () => {
	const res = await get<ICompany>(API_ROUTES.v1.company);
	return res.data;
};

const setCompany = async (body: ICompany) => {
	const res = await put<ICompany>(API_ROUTES.v1.company, body);
	return res.data;
};

export const createProject = async (body: IProjectCreate) => {
	const res = await post<IProjectCreate, IProject>(API_ROUTES.v1.project, body);
	return res.data;
};

export const useProjectSettings = () =>
	useQuery([QueryKeys.projectSettings], () => getProjectSettings());

export const useUpdateProjectSettings = () => {
	const queryClient = useQueryClient();
	return useMutation<IProjectSettings, unknown, IProjectSettings>(
		async (value) => setProjectSettings(value),
		{
			onSuccess: (data) => {
				queryClient.setQueryData([QueryKeys.projectSettings], data);
			}
		}
	);
};

export const deleteProject = async () => {
	await del(API_ROUTES.v1.project);
};

export const useCompany = () =>
	useQuery([QueryKeys.company], () => getCompany());

export const useUpdateCompany = () => {
	const queryClient = useQueryClient();
	return useMutation<ICompany, unknown, ICompany>(
		async (value) => setCompany(value),
		{
			onSuccess: (data) => {
				queryClient.setQueryData([QueryKeys.company], data);
			}
		}
	);
};

export const useCreateProject = (body: IProjectCreate) =>
	useQuery([QueryKeys.createdProject], () => createProject(body));
